import type {
  AclTemplateOptions,
  ProfileQuery,
} from 'src/shared/graphql/generated';
import { useProfileQuery } from 'src/shared/graphql/generated';
import { logError } from 'src/shared/telemetry/logger';
import { isDevelopment } from 'src/shared/utils/environment';

const useCachedProfileQuery = () => {
  const { data } = useProfileQuery({
    fetchPolicy: 'cache-only',
    onCompleted: result => {
      if (!result && isDevelopment()) {
        // eslint-disable-next-line no-console
        console.warn(
          'Must fetch the user profile first to be able ' +
            'to check access. Are you using `useProfileQuery`?',
        );
      }
    },
    onError: logError,
  });

  return data;
};

export const useHasAccessForOrg = (accessesToCheck: AclTemplateOptions[]) => {
  const data = useCachedProfileQuery();

  if (!data) {
    return accessesToCheck.map(() => false);
  }

  const accesses = data?.profile?.user?.aclAccesses;
  const accessSet = new Set(accesses?.map(x => x.aclTemplate));

  return accessesToCheck.map(access => accessSet.has(access));
};

export interface HyperionFeatureAccess {
  org?: ProfileQuery['profile']['user']['orgs'][0];
  featureAccesses: ProfileQuery['profile']['user']['orgs'][0]['featureAccesses'];
}

export const useOrg = (): HyperionFeatureAccess => {
  const data = useCachedProfileQuery();

  return {
    org: data?.profile.user.orgs[0],
    featureAccesses: data?.profile.user.orgs[0].featureAccesses,
  };
};
